import { CATEGORY_LABELS } from "@shared/types";
import type { Band, Category } from "@shared/types";

const dateFmt = new Intl.DateTimeFormat("es-ES", {
  timeZone: "Europe/Madrid",
  weekday: "long",
  day: "numeric",
  month: "short",
});

export function formatGameDate(gameDate: string): string {
  const [y, m, d] = gameDate.split("-").map(Number);
  const date = new Date(Date.UTC(y!, m! - 1, d!, 12));
  const text = dateFmt.format(date);
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function categoryLabel(category: Category): string {
  return CATEGORY_LABELS[category];
}

export const BAND_UI: Record<Band, { cls: string; icon: string; label: string; note: string }> = {
  green: { cls: "good", icon: "✓", label: "✓ Muy cerca", note: "¡Golazo!" },
  yellow: { cls: "mid", icon: "~", label: "~ Cerca", note: "Al palo" },
  red: { cls: "bad", icon: "✕", label: "✕ Lejos", note: "Fuera" },
};

export function formatKm(km: number): string {
  return Math.round(km).toLocaleString("es-ES");
}
